import { useState } from "react";
import { disconnectMetaIntegration, disconnectMicrosoftIntegration, fetchMetaIntegrationExistData } from "../../../js/api/fb-integration";
import SecondaryButton from "../../common/buttons/SecondaryButton";

export default function MetaDeleteModal({setIsMicrosoftIntegration, addToast, isDeleteOpen,isMicrosoftDisconnect, isFbIntegration, setIsFbIntegration, setIsDeleteOpen, imageSrc, setIsLoading }) {

  const disconnectMeta = () => {
    disconnectMetaIntegration(isFbIntegration.metaAdCredentialID).then((res) => {

      fetchMetaIntegrationExistData(setIsFbIntegration).then(() => {
        setIsDeleteOpen(false)
        addToast("Meta integration has been disconnected.", "success")
      }).catch(() => {
        addToast("Unable to Disconnect Meta", 'error')
      })
    })
  }

  const disconnectMicrosoft = () => {
    disconnectMicrosoftIntegration().then((res) => {

      fetchMetaIntegrationExistData(setIsFbIntegration).then(() => {
        setIsMicrosoftIntegration(false)
        setIsDeleteOpen(false)
        addToast("Microsoft integration has been disconnected", "success")
      }).catch(() => {
        addToast("Unable to Disconnect Microsoft", 'error')
      })
    })
  }

  return (
    <>
      {/* Modal */}
      {isDeleteOpen && ( isMicrosoftDisconnect?<div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm z-50">
          <div className="bg-white w-[525px] md:w-[525px] rounded-lg shadow-lg p-[30px]">

            <div className="pt-0"><div className="flex mb-[30px]">
              <img src={imageSrc} className={`w-12 h-12 mr-4`} /><h3 className="font-mont text-[16px] flex items-center font-medium text-[#1B2A3D]"><span>Are you sure you want to disconnect</span>&nbsp;<span className="font-mont font-semibold text-[#1B2A3D]"> {isMicrosoftDisconnect?"Microsoft":"Facebook"}</span> ?</h3>

            </div>
              <div className="flex justify-end">
                <button className="px-5 py-1 rounded-md border primary_btn transition-all duration-500 red_btn h-[42px] text-[14px] font-mont font-[500] mr-[20px]" onClick={disconnectMicrosoft}>Disconnect</button>
                <SecondaryButton label="Cancel" onClick={() => setIsDeleteOpen(false)} />
              </div>
            </div>
          </div>
        </div>:
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm z-50">
          <div className="bg-white w-[525px] md:w-[525px] rounded-lg shadow-lg p-[30px]">

            <div className="pt-0"><div className="flex mb-[30px]">
              <img src={imageSrc} className={`w-12 h-12 mr-4`} /><h3 className="font-mont text-[16px] flex items-center font-medium text-[#1B2A3D]"><span>Are you sure you want to disconnect</span>&nbsp;<span className="font-mont font-semibold text-[#1B2A3D]"> Meta</span> ?</h3>

            </div>
              <div className="flex justify-end">
                <button className="px-5 py-1 rounded-md border primary_btn transition-all duration-500 red_btn h-[42px] text-[14px] font-mont font-[500] mr-[20px]" onClick={disconnectMeta}>Disconnect</button>
                <SecondaryButton label="Cancel" onClick={() => setIsDeleteOpen(false)} />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
